import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiPath from '../../utils/apiPath';

/* fetch records */
// export const fetchRecords = createAsyncThunk(
//   "records",
//   async ( {blockId,userId,page,limit,column,value,operator} ,{ rejectWithValue }) => {
//     try {
//       const response = await apiPath.get(`/api/v1.0/records/${blockId}?limit=${limit}&page=${page}${userId?`&user_id=${userId}`:''}${column?`&field=${column}`:''}${value?`&value=${value}`:''}${operator?`&operator=${operator}`:''}`);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response.data);
//     }
//   }
// );
export const fetchRecords = createAsyncThunk(
  "records",
  async (
    { blockId, userId, page, limit, filters, dateFilter },
    { rejectWithValue }
  ) => {
    try {
      const params = new URLSearchParams();
      params.append("limit", limit);
      params.append("page", page);

      if (userId) {
        params.append("user_id", userId);
      }

      // ✅ All filters combined in single array
      if (filters && filters.length > 0) {
        params.append("filters", JSON.stringify(filters));
      }

      // ✅ Date range filter (optional)
      if (dateFilter) {
        params.append("dateFilter", JSON.stringify(dateFilter));
      }

      const response = await apiPath.get(
        `/api/v1.0/records/${blockId}?${params.toString()}`
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message
      );
    }
  }
);


/* create record */
export const createRecord = createAsyncThunk('record/create',async ({blockId,recordData}, { rejectWithValue }) => {
    try {
      const response = await apiPath.post(`/api/v1.0/records/${blockId}/create`, recordData);
      return response.data;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  }
);


/* update records */
export const updateRecord = createAsyncThunk('record/update',async ({ id,blockId, recordData }, { rejectWithValue }) => {
    try {
      const response = await apiPath.put(`/api/v1.0/records/${blockId}/${id}`, recordData);
      return response.data;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  }
);

/* record detail */
export const recordDetail = createAsyncThunk('record/detail',async ({id,blockId}, { rejectWithValue }) => {
    try {
      const response = await apiPath.get(`/api/v1.0/records/${blockId}/${id}`);
      return response.data;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  }
);

/* delete record */
export const deleteRecord = createAsyncThunk('record/delete',async ({id,blockId}, { rejectWithValue }) => {
    try {
      await apiPath.delete(`/api/v1.0/records/${blockId}/${id}`);
      return id;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  }
);

/* create relatioal record */
export const createRelationalRecord = createAsyncThunk('record/create-related',async (relationalRecordData, { rejectWithValue }) => {
    try {
      const response = await apiPath.post(`/api/v1.0/records/create-related`, relationalRecordData);
      return response.data;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  }
);

/* fetch relational record */
// export const relationalRecordList = createAsyncThunk('record/relationList', async ({blockId}) => {
//   const response = await apiPath.get(`/api/v1.0/records/${blockId}/relation_list`);
//   return response.data;
// });
export const relationalRecordList = createAsyncThunk(
  "record/relationList",
  async ({ blockId, filterFieldId, filterValue }) => {

    let url = `/api/v1.0/records/${blockId}/relation_list`;

    if (filterFieldId && filterValue) {
      url += `?filter_field_id=${filterFieldId}&filter_value=${filterValue}`;
    }

    const response = await apiPath.get(url);

    return response.data;
  }
);

/* add Money */
export const addLedger = createAsyncThunk(
  'record/add-ledger',
  async (formData, { rejectWithValue }) => {

    try {
      const response = await apiPath.post(`/api/v1.0/rfidledger/create`, formData);
      return response.data;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  }
);

export const fetchAllLedger = createAsyncThunk(
  'record/ledgers',
  async ({RFID}, { rejectWithValue }) => {

    try {
      const response = await apiPath.get(`/api/v1.0/rfidledger/${RFID}`);
      return response.data;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  }
);

/* Complete trip */
export const completeTrip = createAsyncThunk(
  'trip/complete',
  async ({block_id,id,facility_id}, { rejectWithValue }) => {

    try {
      const response = await apiPath.post(`/api/v1.0/records/${block_id}/${id}/complete-trip`,{facility_id});
      return response.data;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  }
);

/* Generate QR */
export const generateQr = createAsyncThunk(
  'vehicle/generate-qr',
  async ({block_id,id,vehicleNumber}, { rejectWithValue }) => {

    try {
      const response = await apiPath.post(`/api/v1.0/records/${block_id}/${id}/generate-qr`,{vehicleNumber});
      return response.data;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  }
);

/* fetch system configuration */
export const fetchSystemConfiguration = createAsyncThunk(
  "system/configuration",
  async ( _ ,{ rejectWithValue }) => {
    try {
      const response = await apiPath.get(`/api/v1.0/dynamicids/configs`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

/* fetch block records */
export const fetchBlockRecords = createAsyncThunk(
  "block-records",
  async ( {blockId} ,{ rejectWithValue }) => {
    try {
      const response = await apiPath.get(`/api/v1.0/records/${blockId}/block-records`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

/* search records */
export const searchRecords = createAsyncThunk(
  "records/search",
  async (
    { blockId, searchFieldId, searchValue },
    { rejectWithValue }
  ) => {
    try {
      const params = new URLSearchParams();

      if (searchFieldId && searchValue) {
        params.append(searchFieldId, searchValue);
      }

      const response = await apiPath.get(
        `/api/v1.0/records/${blockId}/search?${params.toString()}`
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message
      );
    }
  }
);

/* Record Slice @start */
const recordSlice = createSlice({
  name: 'record',
  initialState: {
    records: [],
    recordDetails: {},
    recordLists:[],
    recordsPagination:[],
    ledger: [],
    configurations: [],
    blockRecords: [],
    loading: false,
    error: null,
    totalRecord:0,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      /* Fetch Record */
      .addCase(fetchRecords.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRecords.fulfilled, (state, action) => {
        const {records,...pageData} = action.payload
        state.loading = false;
        state.error = null;
        state.records = [];
        state.recordsPagination = pageData
        state.records = records;
         state.totalRecord = action.payload.totalRecord
      })
      .addCase(fetchRecords.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      /* Fetch block Record */
      .addCase(fetchBlockRecords.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBlockRecords.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.blockRecords = [];
        state.blockRecords = action.payload.records;
      })
      .addCase(fetchBlockRecords.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
    
      /* Create Record */
      .addCase(createRecord.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createRecord.fulfilled, (state, action) => {
        const rawData = action.payload;
        const cleanedData = {};
        for (const key in rawData) {
          const cleanedValue = rawData[key];
          if (Array.isArray(cleanedValue)) {
            cleanedData[key] = cleanedValue.map(item =>
              item?.id === undefined ? item : item.name
            );
          } else {
            cleanedData[key] = cleanedValue;
          }
        }
        const data = {
          ...cleanedData,
          created_at: action.payload.created_at,
          updated_at: action.payload.updated_at,
        };
        if (!Array.isArray(state.records)) {
          state.records = [];
        }
        state.records.push(data);
        state.loading = false;
        state.error = null;
        state.totalRecord = state.totalRecord+1
      })
      .addCase(createRecord.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
    
      /* Update Record */
      .addCase(updateRecord.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateRecord.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        const index = state.records.findIndex(
          (record) => record.id === action.payload.id
        );
        if (index !== -1) {
          const rawData = action.payload;
          const cleanedData = {};
          for (const key in rawData) {
            const cleanedValue = rawData[key];
            if (cleanedValue && Array.isArray(cleanedValue)) {
              cleanedData[key] = cleanedValue.map(item =>
                item?.id === undefined ? item : item.name
              );
            } else {
              cleanedData[key] = cleanedValue;
            }
          }
          state.records[index] = cleanedData;
        }
      })
      .addCase(updateRecord.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
    
      /* Delete Record */
      .addCase(deleteRecord.fulfilled, (state, action) => {
        state.records = state.records.filter(
          (record) => record.id !== action.payload
        );
        state.totalRecord = state.totalRecord-1
      })
      .addCase(deleteRecord.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      /* Record Details */
      .addCase(recordDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(recordDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.recordDetails = action.payload.details;
      })
      .addCase(recordDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
    
      /* Relational Record Lists */
      .addCase(relationalRecordList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(relationalRecordList.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.recordLists = action.payload;
      })
      .addCase(relationalRecordList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      /* Create Relational Record */
      .addCase(createRelationalRecord.pending, (state) => {
        state.loading = true;
        state.error = null;
      })   
      .addCase(createRelationalRecord.fulfilled, (state, action) => {
        const newRecord = action.payload;
        console.log('New relational record created:', newRecord);
        // Ensure the basic structure exists
        state.recordDetails = state.recordDetails || {};
        state.recordDetails.related = state.recordDetails.related || {};
        // state.recordDetails[newRecord.field_id].push(newRecord[newRecord.field_id]?.[0]);
        // The API should return which relationship type this belongs to
        // For example: newRecord.relationType = "Asset"
        if (newRecord.block_name) {
          console.log('inside:', newRecord.block_name);
          // Initialize the array for this relation type if it doesn't exist
          state.recordDetails.related[newRecord.block_name] = 
          state.recordDetails.related[newRecord.block_name] || [];
    
          // Push the new record
                        console.log('related records before push:', state.recordDetails);
const { errors, success, message, ...filteredRecord } = newRecord;

state.recordDetails.related[filteredRecord.block_name].push(filteredRecord);

          // state.recordDetails.related[newRecord.block_name].push(newRecord);
              console.log('related records after push:', state.recordDetails);

        } else {
          console.error('New relational record missing relationType:', newRecord);
        }
  
        state.loading = false;
        state.error = null;
      })
      .addCase(createRelationalRecord.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
          /* Add Money */
      .addCase(addLedger.pending, (state) => {
            state.loading = true;
            state.error = null;
          })
          .addCase(addLedger.fulfilled, (state, action) => {
            state.ledger.push(action.payload);
            state.loading = false;
            state.error = null;
          })
          .addCase(addLedger.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
          })

              /* Transaction lists */
      .addCase(fetchAllLedger.pending, (state) => {
            state.loading = true;
            state.error = null;
          })
          .addCase(fetchAllLedger.fulfilled, (state, action) => {
            state.ledger = [];
            state.ledger = action.payload.allLedger;
            state.loading = false;
            state.error = null;
          })
          .addCase(fetchAllLedger.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
          })

                 /* Generate QR */
          .addCase(generateQr.pending, (state) => {
            state.loading = true;
            state.error = null;
          })
          .addCase(generateQr.fulfilled, (state, action) => {
            // state.ledger = [];
            // state.ledger = action.payload.allLedger;
            const index = state.records.findIndex(
              (record) => record.id === action.payload.id
            );
            if (index !== -1) {
              const rawData = action.payload;
              const cleanedData = {};
              for (const key in rawData) {
                const cleanedValue = rawData[key];
                if (cleanedValue && Array.isArray(cleanedValue)) {
                  cleanedData[key] = cleanedValue.map(item =>
                    item?.id === undefined ? item : item.name
                  );
                } else {
                  cleanedData[key] = cleanedValue;
                }
              }
              state.records[index] = cleanedData;
            }
            state.loading = false;
            state.error = null;
          })
          .addCase(generateQr.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
          })

        .addCase(completeTrip.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(completeTrip.fulfilled, (state, action) => {
          state.error = null;
          state.loading = false;
          console.log(action.payload,action.payload.id)
          const index = state.records.findIndex(
            (record) => record.id === action.payload?.record?.id
          );
          console.log(index,'index')
          if (index !== -1) {
            const rawData = action.payload.record || action.payload;
            console.log(rawData,'raw data');
            const cleanedData = {};
            for (const key in rawData) {
              const cleanedValue = rawData[key];
              if (cleanedValue && Array.isArray(cleanedValue)) {
                cleanedData[key] = cleanedValue.map(item =>
                  item?.id === undefined ? item : item.name
                );
              } else {
                cleanedData[key] = cleanedValue;
              }
            }
            console.log(cleanedData,'clean data')
            state.records[index] = cleanedData;
          }
        })
        .addCase(completeTrip.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        })
      /* Fetch Configurations */
      .addCase(fetchSystemConfiguration.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSystemConfiguration.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.configurations = action.payload.configs
      })
      .addCase(fetchSystemConfiguration.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      /* Search Records */
.addCase(searchRecords.pending, (state) => {
  state.loading = true;
  state.error = null;
})
.addCase(searchRecords.fulfilled, (state, action) => {
  const { records, ...pageData } = action.payload;

  state.loading = false;
  state.error = null;
  state.recordsPagination = pageData;
})
.addCase(searchRecords.rejected, (state, action) => {
  state.loading = false;
  state.error = action.payload?.message || action.error.message;
})
  },
});

export default recordSlice.reducer;
